module.exports = __webpack_public_path__ + "static/media/client-logos.fcddf1a9.png";